export default "__VITE_ASSET__D2afw8BO__"